export const legends = {
  aoi: {
    type: "line",
    outline: "red",
    width: 5,
    opacity: 1
  },
  sectors: {
    type: "line",
    outline: "black",
    width: 2,
    opacity: 0.6
  },
  greenspaces: {
    type: "fill",
    outline: "black",
    fill: "#AAE08F",
    opacity: 0.9
  },
  buildings: {
    type: "fill",
    outline: "black",
    fill: "#0D9AD0",
    opacity: 1
  },
  "clustered-buildings": {
    type: "fill",
    outline: "black",
    fill: "red",
    opacity: 1
  },
  "drone-cover": {
    type: "image",
    outline: "black"
  },
  "mapillary-images": {
    type: "circle",
    fill: "#008000"
  }
};
